import { useState } from 'react'

import { Tab } from 'components'
import { useLoading, useModal } from 'hooks'
import moment from 'moment'
import { ConventionServices } from 'services/NGT/Convention'

import { ConventionRegistrationForm } from './components'
import { SearchConventionTable } from './components'

const tabs = ['Pesquisar', 'Adicionar Novo']

export default function ConventionRegistration() {

  const [selectedTab, setSelectedTab] = useState<number>(0)

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <SearchConventionTable />}
      {selectedTab === 1 && (
        <ConventionRegistrationForm
          setSelectedTab={setSelectedTab}
        />
      )}
    </>
  )
}
